import SplashScreen from "./SplashScreen";
import splashScreenTasks from "./helpers/splashScreenTasks";

export { splashScreenTasks };
export default SplashScreen;
